import { SVGProps } from "react";

export const CourseAnimationSvg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 199 254"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#course-top)">
      <path
        d="M67.86 175.47c0 .46.06.88.07 1.25 0 1.75.07 3.49.09 5.23l7.22 13.27c-.42-2.77-.82-5.55-1.14-8.33l-6.24-11.42Z"
        fill="#865D34"
      />
      <path
        d="m67.86 175.47-1.92-3.53-2 2.47 4.1 7.54c0-1.74-.06-3.48-.09-5.23-.03-.37-.05-.79-.09-1.25Z"
        fill="#9C6D45"
      />
      <path
        d="M80.82 199.2c0 2.18.08 4.37.15 6.56l4.84 8.89c.23-1.77.42-3.55.54-5.33l-5.53-10.12Z"
        fill="#865D34"
      />
      <path
        d="M74.13 186.89c.32 2.78.72 5.56 1.14 8.33L81 205.76c-.07-2.19-.13-4.38-.15-6.56l-6.72-12.31ZM95.68 226.41l-9.33-17.09a86.64 86.64 0 0 1-.54 5.33l7.21 13.25 2.66-1.49Z"
        fill="#9C6D45"
      />
      <path
        d="M132.46 212.69c-.09-.23-9.15-22.74-7.45-39l-1-.1c-1.73 16.54 7.42 39.27 7.52 39.5l.93-.4Z"
        fill="#659522"
      />
      <path
        d="M124.6 173.69s-2.44-3.5 1.43-7.37c0-.02 2.79 3.5-1.43 7.37ZM124.52 180.6s-.64-4.36 4.26-6.77c0 0 .94 4.52-4.26 6.77ZM124.55 183.05a4.104 4.104 0 0 1-2.888-1.282 4.106 4.106 0 0 1-1.112-2.958s4.27-.12 4 4.24Z"
        fill="#659522"
      />
      <path
        d="M125.74 192.3s-5.12.52-5.85-4.47c0 0 5.41-.81 5.85 4.47Z"
        fill="#3B8529"
      />
      <path
        d="M128.13 201.69s-6.74 1.4-8.54-4.88c.01-.04 7.11-1.86 8.54 4.88Z"
        fill="#659522"
      />
      <path
        d="M125.23 188.38s-.31-5.8 6.22-8.44c0 0 .68 6.04-6.22 8.44Z"
        fill="#3B8529"
      />
      <path
        d="M127.42 197.06s-1-4.59 4.14-7.45c0 0 1.33 4.74-4.14 7.45Z"
        fill="#659522"
      />
      <path
        d="M107.04 158.28c-.08.45-.16.87-.25 1.23-.4 1.7-.803 3.397-1.21 5.09l3.71 14.64c.28-2.79.58-5.57 1-8.35l-3.25-12.61Z"
        fill="#865D34"
      />
      <path
        d="m107.04 158.28-1-3.9-2.56 1.89 2.1 8.33c.413-1.693.817-3.39 1.21-5.09.09-.36.17-.82.25-1.23Z"
        fill="#9C6D45"
      />
      <path
        d="M113.71 184.48c-.52 2.12-1 4.26-1.48 6.39l2.48 9.81c.67-1.65 1.29-3.33 1.84-5l-2.84-11.2Z"
        fill="#865D34"
      />
      <path
        d="M110.25 170.89c-.38 2.78-.68 5.56-1 8.35l2.94 11.63c.47-2.13 1-4.27 1.48-6.39l-3.42-13.59ZM121.36 214.53l-4.81-18.84c-.55 1.7-1.17 3.38-1.84 5l3.7 14.63 2.95-.79Z"
        fill="#9C6D45"
      />
      <path
        d="M137.41 187.48s4.56-3.32 2.91-8.78c0-.01-4.94 3.25-2.91 8.78ZM137.04 193.82s5.17-.17 6.85-6.1c0-.03-5.42-.12-6.85 6.1ZM136.93 198.77s0-5.54-5.45-6c0 .03-.3 5.92 5.45 6Z"
        fill="#659522"
      />
      <path
        d="M137.22 186.69c-.1.8-2.34 19.68 2.22 26.44l.8-.54c-4.36-6.46-2.08-25.59-2.06-25.79l-.96-.11Z"
        fill="#659522"
      />
      <path
        d="M151.48 150.36c-.19.41-.38.8-.55 1.12l-2.47 4.61-.17 15.11c1-2.63 2-5.24 3.07-7.83l.12-13.01Z"
        fill="#865D34"
      />
      <path
        d="M151.48 150.36v-4l-3 1.17-.09 8.59 2.47-4.61c.27-.35.43-.74.62-1.15Z"
        fill="#9C6D45"
      />
      <path
        d="M151.22 177.39c-1.05 1.92-2.06 3.86-3.06 5.8l-.12 10.12a73.46 73.46 0 0 0 3.07-4.39l.11-11.53Z"
        fill="#865D34"
      />
      <path
        d="M151.36 163.37c-1.08 2.59-2.08 5.2-3.07 7.83l-.13 12c1-1.94 2-3.88 3.06-5.8l.14-14.03ZM150.93 208.4l.18-19.48c-1 1.5-2 3-3.07 4.39l-.16 15.09h3.05Z"
        fill="#9C6D45"
      />
      <path
        d="M137.82 212.33c.26-.26 26-26.1 47.64-34l-.33-.91c-21.87 8-47.74 34-48 34.24l.69.67Z"
        fill="#659522"
      />
      <path
        d="M185.2 178.01a8.192 8.192 0 0 1 10-2.7 7.59 7.59 0 0 1-10 2.7Z"
        fill="#659522"
      />
      <path
        d="M176.24 182.21a8.197 8.197 0 0 1 10.28 1.35 7.57 7.57 0 0 1-10.28-1.35Z"
        fill="#3B8529"
      />
      <path
        d="M173.13 183.76a7.002 7.002 0 0 1 4-7.85 6.442 6.442 0 0 1-4 7.85ZM161.62 191.06a8.722 8.722 0 0 1 3.61-10.37 8.048 8.048 0 0 1-3.61 10.37Z"
        fill="#659522"
      />
      <path
        d="M150.46 199.99a11.47 11.47 0 0 1 3.15-14.16s4.95 8.13-3.15 14.16Z"
        fill="#3B8529"
      />
      <path
        d="M166.48 187.96a10.672 10.672 0 0 1 13.17 2.89s-7.52 4.61-13.17-2.89ZM156.13 196.2a8.813 8.813 0 0 1 11.12.79s-5.64 4.7-11.12-.79Z"
        fill="#659522"
      />
      <path
        d="M148.92 217.86c-.08-.4-7.22-40.4 43.1-77.51l-.58-.78c-26.54 19.58-36.95 39.85-41 53.4-4.41 14.72-2.48 25-2.46 25.07l.94-.18Z"
        fill="#659522"
      />
      <path
        d="M176.42 153.29a13.16 13.16 0 0 1 15.91-4.88s-5.31 9.54-15.91 4.88Z"
        fill="#659522"
      />
      <path
        d="M181.13 149.08a11.187 11.187 0 0 1 .58-14.13s6.16 6.95-.58 14.13Z"
        fill="#659522"
      />
      <path
        d="M189.26 142.46a11.19 11.19 0 0 1 9.11-10.77s.6 9.21-9.11 10.77Z"
        fill="#3B8529"
      />
      <path
        d="M166.69 164.88s-6.2-9.07 2-17.58c.03 0 7.06 9.23-2 17.58Z"
        fill="#659522"
      />
      <path
        d="M154.18 182.95s-10.46-10-2.19-23.19c0 0 11.58 9.93 2.19 23.19ZM165.13 166.37s8.08-10.75 21.15-4.56c.03 0-7.9 11.76-21.15 4.56Z"
        fill="#3B8529"
      />
      <path
        d="M153.37 187.34s5.33-9.76 16.76-6.26c0 0-5.08 10.61-16.76 6.26Z"
        fill="#659522"
      />
      <path
        d="M104.7 253.38s-18.48-31.3-18.32-34.07c.16-2.77 64.54-19.78 66.46-19.39 1.92.39 2.68 38.31 2.68 38.31l-50.82 15.15Z"
        fill="#614018"
      />
      <path
        d="M154 205.36c-22.34 5.31-44.73 10.38-67 15.92.53 1.24 1.37 3 2.4 4.94 21.6-5.68 43.31-11 65-16.46-.15-1.6-.27-3.07-.4-4.4Z"
        fill="#614018"
      />
      <path
        d="M152.84 199.92c-1.92-.39-66.31 16.63-66.46 19.39.085.697.291 1.374.61 2 22.28-5.54 44.67-10.61 67-15.92-.32-3.25-.7-5.38-1.15-5.47Z"
        fill="#7E5320"
      />
      <path
        d="m104.7 253.38 50.82-15.15s0-2.17-.14-5.48c-17.87 5.19-35.76 10.35-53.62 15.6 1.76 3.03 2.94 5.03 2.94 5.03Z"
        fill="#614018"
      />
      <path
        d="M101.76 248.35c17.86-5.25 35.75-10.41 53.62-15.6 0-1.4-.09-3-.14-4.75-19.06 4.68-38.2 8.95-57.19 13.92 1.36 2.38 2.64 4.59 3.71 6.43ZM93.82 234.43c1 1.71 1.94 3.46 2.9 5.15 19.27-6 38.8-11.29 58.34-16.49-.06-1.54-.13-3.12-.2-4.7-20.35 5.3-40.73 10.61-61.04 16.04ZM154.58 213.05c-.07-1.14-.14-2.24-.21-3.29-21.67 5.49-43.38 10.78-65 16.46.76 1.47 1.63 3.1 2.56 4.8.8-.23 1.6-.47 2.4-.68 20.16-5.47 40.28-11.16 60.25-17.29Z"
        fill="#7E5320"
      />
      <path
        d="m96.72 239.58 1.33 2.34c19-5 38.13-9.24 57.19-13.92-.05-1.55-.11-3.21-.18-4.91-19.54 5.2-39.07 10.51-58.34 16.49ZM154.58 213.05c-20 6.13-40.09 11.82-60.23 17.29-.8.21-1.6.45-2.4.68.6 1.11 1.23 2.25 1.87 3.41 20.33-5.43 40.69-10.71 61-16-.04-1.85-.14-3.66-.24-5.38Z"
        fill="#614018"
      />
      <path
        d="M66.9 179.74s63.91-16.19 84.89-22.27c0 0 35.53-47.14 19-99.95C150.42-7.31 91.32-3.73 61.63 4.33c-33.69 9.14-75.91 43-56.9 107.76 12.53 42.71 62.17 67.65 62.17 67.65Z"
        fill="#F7C642"
      />
      <path
        d="m109.43 1.25-2.17-.32c-26 10-51.91 16.39-76.93 18.9-.54.4-1.06.82-1.59 1.24 26.21-2.45 53.39-9.17 80.69-19.82ZM118.59 20.77c6.69-2.74 13.33-5.65 19.92-8.66l-1.07-.67C102.83 27.26 67.13 39.76 29.89 42.99c-6.711.519-13.45.592-20.17.22-.21.35-.41.7-.6 1.06a154.57 154.57 0 0 0 20.87-.19c27.14-2.39 56.14-9.98 88.6-23.31ZM28.43 69.3c30.88-4 61-8.49 90.16-18.83a391.858 391.858 0 0 0 40.82-17.42l-.6-.92a388.303 388.303 0 0 1-40.59 17.31C89.13 59.75 59.13 64.21 28.29 68.22l-12.9 1.81c-4.93.71-9.9 1.43-14.89 2.06 0 .37-.07.74-.11 1.11 5.08-.64 10.14-1.37 15.16-2.09l12.88-1.81ZM139.2 64.26c10.06-3.48 20.06-7.23 30-11.25-.13-.34-.25-.69-.37-1-9.96 4-19.96 7.75-30 11.25A611.62 611.62 0 0 1 25.99 90.88c-8.2 1.18-16.62 2-25.21 2.6 0 .36.08.72.13 1.08 8.6-.56 17-1.42 25.23-2.6a613.08 613.08 0 0 0 113.06-27.7ZM127.35 90.5c14.11-5.47 30.05-11.85 46.63-19.17-.06-.37-.11-.74-.18-1.11-16.67 7.35-32.67 13.77-46.85 19.27-31 12-63.09 19.68-98.17 23.46-7.51.8-15.26 1.55-23.12 2.05l.36 1.07c7.78-.5 15.44-1.24 22.87-2 35.24-3.82 67.39-11.52 98.46-23.57ZM125.2 120.3a421.52 421.52 0 0 0 48.87-18.61c.06-.42.12-.85.17-1.27a424.13 424.13 0 0 1-49.35 18.86c-26.64 8.16-55.37 13.89-87.84 17.52-6.78.76-13.13 1.24-19.14 1.46l.78 1.06c5.82-.23 12-.71 18.48-1.44 32.54-3.65 61.33-9.4 88.03-17.58ZM128.05 146.36c-27.1 8-55.08 16.24-83.25 19l1.27 1c27.87-2.88 55.52-11 82.29-18.92l7.7-2.27c8.56-2.51 17.81-5.3 27.54-8.43l.6-1.34c-10.06 3.25-19.62 6.14-28.45 8.72l-7.7 2.24Z"
        fill="#F38E1E"
      />
      <path
        d="M146.4 45.96c-25.6-3.87-40.09 1.24-48.19 9.23-7.41-19.41-31-33.18-31-33.18-10.66 18.47-12.9 32.14-10.85 42.24-19.27-1.29-39.82 9.88-39.82 9.88 15.45 28 31.47 34.26 44.34 32.72-13.26 19.85-1 53.13-1 53.13 30.53-11.42 38.76-26.7 38.81-39.82 17.86 16.3 53.13 8.2 53.13 8.2-5.78-24.52-15.54-36.12-25.68-40.91 15.9-13.76 20.26-41.49 20.26-41.49ZM88.62 92.13v1.46c-.45-.57-.73-.88-.73-.88-.48 0-.94.1-1.4.16.48-.51.73-.81.73-.81 0-.21-.11-.41-.16-.62.9.2 1.41.28 1.41.28.26-.25.49-.51.74-.76v.16l.6.25c-.77.47-1.19.76-1.19.76Z"
        fill="#F57B31"
      />
      <path
        d="M87.87 92.69c-.48 0-.94.1-1.4.16-2.68 2.86-12.49 12.42-25.55 14-13.26 19.85-1 53.13-1 53.13 30.53-11.42 38.76-26.7 38.81-39.82-6.1-5.57-10.17-14-10.1-26.57-.5-.57-.76-.9-.76-.9Z"
        fill="#F78300"
      />
      <path
        d="M86.47 92.87c-12.88 1.56-20.84 6.91-25.55 14 13.06-1.58 22.87-11.18 25.55-14Z"
        fill="#F35F00"
      />
      <path
        d="M126.13 87.45c-8.47 7.35-20.22 10.76-36.33 3.92-.78.47-1.2.76-1.2.76v1.46c2.43 3.06 10.15 13.78 10.1 26.57 17.86 16.3 53.13 8.2 53.13 8.2-5.78-24.52-15.54-36.12-25.7-40.91Z"
        fill="#F78300"
      />
      <path
        d="M88.6 93.59c-.07 12.57 4 21 10.1 26.57.05-12.79-7.67-23.47-10.1-26.57Z"
        fill="#F35F00"
      />
      <path
        d="M146.4 45.96c-25.6-3.87-40.09 1.24-48.19 9.23 4.07 10.67 3.25 23-9 35.77v.16l.6.25c4.49-2.68 20.86-11.24 36.33-3.92 15.9-13.76 20.26-41.49 20.26-41.49Z"
        fill="#F78300"
      />
      <path
        d="M89.82 91.37c16.11 6.84 27.86 3.43 36.33-3.92-15.47-7.32-31.84 1.24-36.33 3.92Z"
        fill="#F35F00"
      />
      <path
        d="M56.4 64.25c-19.27-1.29-39.82 9.88-39.82 9.88 15.45 28 31.47 34.26 44.34 32.72 4.71-7.07 12.67-12.42 25.55-14 .48-.51.73-.81.73-.81 0-.21-.11-.41-.16-.62-5.66-1.23-26.57-7.16-30.64-27.17Z"
        fill="#F78300"
      />
      <path
        d="M67.25 22.01C56.59 40.48 54.35 54.15 56.4 64.25c13.08.87 25.55 7.49 30.64 27.19.9.2 1.41.28 1.41.28.26-.25.49-.51.74-.76-.42-2.06-4.18-22.75 9-35.77-7.39-19.41-30.94-33.18-30.94-33.18Z"
        fill="#F78300"
      />
      <path
        d="M56.4 64.25c4.07 20 25 25.94 30.64 27.19-5.09-19.7-17.56-26.32-30.64-27.19ZM98.21 55.19c-13.2 13-9.44 33.71-9 35.77 12.25-12.73 13.07-25.1 9-35.77Z"
        fill="#F35F00"
      />
      <path
        d="M85.06 87.6c-.54-2.08-.92-9.63 2.7-9.72 4-.09 1.78 6.44 1.39 8.43 1-1.9 5.26-7 8-5.51 3.11 1.75-2.95 6.5-4.08 7.95 1.32-1.68 14.2.67 9.82 5-2.36 2.32-8.17-.1-11-.3 1.33 1.8 10.12 8.65 5.85 11.71-3.68 2.64-8.27-7.76-9.48-9.8-.47 2.84 3.78 12.23-1.14 13.31-2.43-3.34-1.81-8.35-1.55-12.18-1.25 1.75-5.61 11.22-9.16 8.56-1.78-1.33.25-4.7 1-5.94a15.159 15.159 0 0 1 2.28-2.73 23.003 23.003 0 0 1 3.37-2.45c-1.8.75-5.72 2.08-7.61 1.36-2.37-.91-1.73-2.43 0-3.46 1.73-1.03 6.32-.2 8.27.19-1.53-2.32-7.42-6.31-6.26-9.87 1.67-5.06 6.55 3.86 7.6 5.45Z"
        fill="#EEE"
      />
      <path
        d="M104.03 79.22a1.002 1.002 0 0 1-.7 1.22 1.001 1.001 0 1 1 .7-1.22ZM108.74 71.81a1 1 0 1 1-1.925.537 1 1 0 0 1 1.925-.537ZM116.34 75.01a.994.994 0 0 1-.351 1.057.999.999 0 1 1 .351-1.057ZM120.13 65.21a1.002 1.002 0 0 1-.7 1.22 1 1 0 1 1 .7-1.22ZM125.07 56.56a1 1 0 1 1-1.925.537 1 1 0 0 1 1.925-.537ZM132.36 68.32a1 1 0 0 1-.7 1.21 1 1 0 0 1-1.21-.69 1.002 1.002 0 0 1 .73-1.087 1 1 0 0 1 1.18.567ZM110.94 58.35a.994.994 0 0 1-.351 1.057.998.998 0 0 1-1.604-.92.999.999 0 0 1 1.955-.137ZM120.3 47.62a1.002 1.002 0 0 1-.644 1.395.999.999 0 0 1-1.256-.885.999.999 0 0 1 .69-1.21 1.001 1.001 0 0 1 1.21.7ZM137.77 51.69a.999.999 0 0 1-1.754.868 1.003 1.003 0 0 1-.083-1.114 1.004 1.004 0 0 1 1.001-.496.998.998 0 0 1 .836.742ZM124.85 76.21a1 1 0 1 1-1.925.537 1 1 0 0 1 1.925-.537ZM106.47 105.46a.996.996 0 0 1-.886 1.276 1.004 1.004 0 0 1-1.066-1.13.997.997 0 0 1 .742-.836.999.999 0 0 1 1.21.69ZM119.87 97.69a.998.998 0 0 1-.886 1.276 1 1 0 1 1 .886-1.276ZM117.41 108.05a.999.999 0 0 1-1.453 1.146.992.992 0 0 1-.5-.996 1 1 0 0 1 1.953-.15ZM130.13 99.03a1.002 1.002 0 0 1-.886 1.276 1.004 1.004 0 0 1-1.066-1.13.999.999 0 0 1 1.487-.736c.226.129.393.34.465.59ZM108.56 117.47a1.003 1.003 0 0 1-.73 1.087 1.002 1.002 0 0 1-1.18-.567 1.003 1.003 0 0 1 .7-1.22 1.002 1.002 0 0 1 1.21.7ZM121.05 122.56a.999.999 0 0 1-1.464 1.135 1.007 1.007 0 0 1-.49-1.003 1.007 1.007 0 0 1 .744-.832 1 1 0 0 1 1.21.7ZM128.94 109.6a1.003 1.003 0 0 1-.73 1.087 1.002 1.002 0 0 1-1.18-.567.998.998 0 0 1 .655-1.363 1.011 1.011 0 0 1 .82.135 1.002 1.002 0 0 1 .435.708ZM129.27 119.45a.996.996 0 0 1-.886 1.276 1.004 1.004 0 0 1-1.066-1.13.997.997 0 0 1 .742-.836.999.999 0 0 1 1.21.69ZM141.81 109.62a.999.999 0 0 1-1.464 1.135 1.007 1.007 0 0 1-.49-1.003 1.007 1.007 0 0 1 .744-.832 1 1 0 0 1 1.21.7ZM140.65 123.69a1.002 1.002 0 0 1-.886 1.276 1.004 1.004 0 0 1-1.066-1.13.997.997 0 0 1 .742-.836.999.999 0 0 1 1.21.69ZM87.87 133.9a1 1 0 1 1-1.937.5 1 1 0 0 1 1.937-.5ZM91.65 124.1a1 1 0 1 1-1.934.513 1 1 0 0 1 1.934-.513ZM83.72 114.27a1.001 1.001 0 1 1-1.987.245 1.001 1.001 0 0 1 1.987-.245ZM69.59 112.84a1.001 1.001 0 1 1-1.987.245 1.001 1.001 0 0 1 1.987-.245ZM79.4 124.21a1 1 0 1 1-1.934.513 1 1 0 0 1 1.934-.513ZM62.22 124.49a1 1 0 0 1-.69 1.21.997.997 0 0 1-1.166-.278.993.993 0 0 1-.218-.801 1 1 0 0 1 .864-.831 1 1 0 0 1 1.21.7ZM72.04 132.69a1.002 1.002 0 0 1-.7 1.21.999.999 0 0 1-1.21-.69 1.001 1.001 0 0 1 1.91-.52ZM79.18 140.69a.999.999 0 1 1-1.924.538.999.999 0 0 1 1.924-.538ZM62.2 140.57a1.002 1.002 0 0 1-1.08 1.385 1.012 1.012 0 0 1-.69-.464 1 1 0 1 1 1.77-.921ZM67.36 148.82a1 1 0 1 1-1.921.557 1 1 0 0 1 1.921-.557ZM63.64 96.32a1 1 0 1 1-1.9.52 1 1 0 0 1 .69-1.21 1 1 0 0 1 1.21.69ZM69.13 88.41a1 1 0 1 1-1.922.557 1 1 0 0 1 1.922-.557ZM60.64 79.89a1 1 0 1 1-1.937.499 1 1 0 0 1 1.937-.499ZM47.18 98.16a1 1 0 1 1-1.927.538 1 1 0 0 1 1.927-.538ZM54.84 87.6a1 1 0 1 1-1.922.557 1 1 0 0 1 1.922-.557ZM40.56 92.06a1 1 0 1 1-1.933.512 1 1 0 0 1 1.933-.512ZM41.39 78.97a1 1 0 1 1-1.922.557 1 1 0 0 1 1.922-.557ZM47.81 68.16a1 1 0 1 1-1.922.557 1 1 0 0 1 1.922-.557ZM28.52 78.96a1 1 0 1 1-1.927.538 1 1 0 0 1 1.927-.538ZM67.97 59.48a1 1 0 0 1-.69 1.21 1 1 0 1 1-.52-1.91 1 1 0 0 1 1.21.7ZM82.86 64.79a1 1 0 1 1-1.9.52 1 1 0 0 1 .69-1.21 1 1 0 0 1 1.21.69ZM89.21 53.69a1 1 0 1 1-1.9.52A1 1 0 0 1 88 53a1 1 0 0 1 1.21.69ZM77.38 54.29a1 1 0 1 1-1.9.52 1 1 0 0 1 .69-1.21 1 1 0 0 1 1.21.69ZM90.05 90.33a2.37 2.37 0 1 1-2.92-1.64 2.362 2.362 0 0 1 2.92 1.64ZM61.59 55.36a1 1 0 1 1-1.922.557 1 1 0 0 1 1.922-.557ZM67.2 44.78a1 1 0 1 1-1.927.538 1 1 0 0 1 1.927-.538ZM81.36 44.15a1 1 0 1 1-1.922.552 1 1 0 0 1 1.922-.552ZM73.42 34.32a1 1 0 1 1-1.9.51 1 1 0 1 1 1.9-.51ZM67.66 30.32a1 1 0 1 1-1.9.52 1 1 0 0 1 .69-1.21 1 1 0 0 1 1.21.69Z"
        fill="#FEC444"
      />
      <path
        d="M40.73 119.12c-1.5.79-3.5 1.29-4.79 2.11a20.591 20.591 0 0 0 7.07-2.41 62.527 62.527 0 0 0 10.17-6.4c.091-.628.225-1.25.4-1.86l-.62.12a24.08 24.08 0 0 1-4.94 3.89c-2.38 1.58-4.77 3.21-7.29 4.55Z"
        fill="#98B742"
      />
      <path
        d="M43.01 118.82a20.591 20.591 0 0 1-7.07 2.41c1.29-.82 3.29-1.32 4.79-2.11 2.52-1.34 4.91-3 7.29-4.55a24.08 24.08 0 0 0 4.94-3.89c-3 .59-6.17.15-9.21 1.18a26.223 26.223 0 0 0-9.21 5.64c-3.24 3-5.21 6.7-8.77 9.28 3.59 1.51 10.27.7 15-.24a13.06 13.06 0 0 0 2.78-.9 18.145 18.145 0 0 0 8.19-7.67 32.003 32.003 0 0 0 1.42-5.55 62.518 62.518 0 0 1-10.15 6.4Z"
        fill="#659042"
      />
      <path
        d="M146.71 87.5c1.25.51 2.57 1.48 3.72 1.85a16.404 16.404 0 0 0-5.06-3.09 49.407 49.407 0 0 0-9.07-3c-.432.261-.879.495-1.34.7l.39.32c1.666.133 3.307.486 4.88 1.05a67.392 67.392 0 0 1 6.48 2.17Z"
        fill="#98B742"
      />
      <path
        d="M145.37 86.26a16.406 16.406 0 0 1 5.06 3.09c-1.15-.37-2.47-1.34-3.72-1.85a67.323 67.323 0 0 0-6.48-2.15 18.916 18.916 0 0 0-4.88-1.05c1.9 1.56 3.21 3.69 5.39 5a20.545 20.545 0 0 0 8.12 2.77c3.49.46 6.75-.21 10.13.66-.9-3-4.79-6.64-7.77-9.06-.618-.49-1.289-.91-2-1.25a14.481 14.481 0 0 0-8.85-1.12c-1.425.528-2.8 1.18-4.11 1.95a49.414 49.414 0 0 1 9.11 3.01Z"
        fill="#659042"
      />
    </g>
    <defs>
      <clipPath id="course-top">
        <path fill="#fff" d="M0 0h198.38v253.38H0z" />
      </clipPath>
    </defs>
  </svg>
);
